<template>
 <div>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom"  class="demo-form-inline" label-width="110px" size="mini">
        <el-form-item label="客户名称:">
          <el-select  v-model="searchFrom.customerTaxId" filterable placeholder="请选择">
            <el-option v-for="item in kehuList" :label="item.custerName" :value="item.taxpayerNumber" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
       <div class="searchBtnBox">
         <el-form-item >
            <el-button type="primary" @click="getList(searchFrom)">查询</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="resetForm">重置</el-button>
          </el-form-item>
          <el-form-item   v-if="btnFlg[0]" >
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[2]" >
            <el-button type="primary"  @click="delDeiver">删除</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border  class="tableComent">
      <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  v-if="btnFlg[1]"  @click="modifyRegion(scope.row)">修改</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="customerName" min-width="300"  :formatter="emptyFn" label="客户名称"></el-table-column>
        <el-table-column label="背景颜色"  min-width="120">
            <template slot-scope="scope">
             <div :style="{background:scope.row.colourNo,height:'20px',width:'80px',margin:'0 auto'}"></div>
            </template>
        </el-table-column>
        <el-table-column label="内容颜色"  min-width="120">
            <template slot-scope="scope">
             <div :style="{background:scope.row.ext1,height:'20px',width:'80px',margin:'0 auto'}"></div>
            </template>
        </el-table-column>
        <el-table-column prop="createUser" min-width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[20,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="400px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
          <el-form-item label="客户名称:" prop="customerName" >
            <el-select  v-model="addFrom.customerName" filterable placeholder="请选择"  >
              <el-option v-for="item in kehuList" :label="item.custerName" :value="item.custerName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="背景颜色:" prop="colourNo" class="yansebox" >
            <el-color-picker v-model="addFrom.colourNo"></el-color-picker>
          </el-form-item>
          <el-form-item label="内容颜色:" prop="ext1" class="yansebox"  >
            <el-color-picker v-model="addFrom.ext1"></el-color-picker>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getRelationCustomer, findCustomerColourList, deleteCustomerColour,
  updateCustomerColour, addCustomerColour } from '@/api/wms-stock.js'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  components: {

  },
  data () {
    return {
      isAdd: false,
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      title: '新增',
      dialogVisible: false,
      kehuList: [], // 客户列表
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      loading: 'false',
      rules: {
        customerName: [
          { required: true, message: '请选择客户名称', trigger: 'blur' }
        ],
        colourNo: [
          { required: true, message: '请选择背景颜色', trigger: 'blur' }
        ],
        ext1: [
          { required: true, message: '请选择内容颜色', trigger: 'blur' }
        ]

      },
      addFrom: {},
      btnFlg: [],
      btnIdArr: ['003M4O0400', '003M4O0500', '003M4O0600']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    getRelationCustomer({}).then((res) => {
      this.kehuList = res
    }).catch((err) => {
      this.$message.error(err.message)
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 200) + 'px'
  },
  methods: {
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.masterId = this.masterId
      findCustomerColourList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新增'
      this.addFrom = { colourNo: '#E6A23C', ext1: '#333333' }
      this.dialogVisible = true
      this.isAdd = true
    },
    // 修改
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let json1 = this.kehuList.filter(item => item.custerName == this.addFrom.customerName)
          this.$set(this.addFrom, 'customerTaxId', json1[0].taxpayerNumber)
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.isAdd) {
            addCustomerColour(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            updateCustomerColour(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },

    // 删除
    delDeiver () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteCustomerColour({ ids: selectData.map(item => item.id) }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        dictionaryType: 'financial_settings'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox /deep/.el-input__inner{
  width: 178px;
}
/deep/.yansebox .el-form-item__content{
  width: 150px;
}
.searchBtnBox{
  margin: 0;
}
</style>
